<script>
import UploadWrapper from '@/components/upload/UploadWrapper.vue'
import DocumentValidation from '@/components/document-validation/DocumentValidation.vue'
import Checkout from '@/components/checkout/Checkout.vue'
import PaymentConfirmation from '@/components/upload/PaymentConfirmation.vue'
import PaymentError from '@/components/upload/PaymentError.vue'
export default {
  components: {
    DocumentValidation,
    UploadWrapper,
    Checkout,
    PaymentConfirmation,
    PaymentError
  },
  props: {
    step: { type: Number },
    nextStep: { type: Function },
    order: { type: Object } // comes from upload-view
  },
  data: () => ({
    light: true,
    altLabels: true,
    editable: false,
    showErr: false
  })
}
</script>
<template>
  <div>
    <v-stepper v-model="step" :alt-labels="altLabels" :light="light">
      <v-stepper-header>
        <v-stepper-step step="1" :complete="step > 1" :editable="editable">
          <div class="text-center">
            <h3>{{ $t('component.upload.wizard.step1.header') }}</h3>
            <p>{{ $t('component.upload.wizard.step1.description') }}</p>
          </div>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step
          step="2" :complete="step > 2" :editable="editable"
          :style="$permissions.hasSkipPayment ? 'position: absolute; left: 50%; transform: translateX(-50%); text-align: center;' : ''">
          <div class="text-center">
            <h3>{{ $t('component.upload.wizard.step2.header') }}</h3>
            <p>{{ $t('component.upload.wizard.step2.description') }}</p>
          </div>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step v-if="!$permissions.hasSkipPayment" step="3" :complete="step > 3" :editable="editable">
          <div class="text-center">
            <h3>{{ $t('component.upload.wizard.step3.header') }}</h3>
            <p>{{ $t('component.upload.wizard.step3.description') }}</p>
          </div>
        </v-stepper-step>
        <v-divider></v-divider>
        <v-stepper-step :step="$permissions.hasSkipPayment ? 3 : 4" :editable="editable">
          <div class="text-center">
            <h3>{{ $t('component.upload.wizard.step4.header') }}</h3>
            <p>{{ $t('component.upload.wizard.step4.description') }}</p>
          </div>
        </v-stepper-step>
      </v-stepper-header>
      <v-stepper-items>
        <v-stepper-content step="1">
          <UploadWrapper v-if="step == 1" :next-step="nextStep" />
        </v-stepper-content>
        <v-stepper-content step="2">
          <DocumentValidation
            v-if="step == 2"
            :next-step="nextStep"
            :order="order"
          />
        </v-stepper-content>
        <v-stepper-content step="3">
          <Checkout
            v-if="step == 3 && !$permissions.hasSkipPayment"
            :order="order"
            :next-step="nextStep" />
          <PaymentError v-model="showErr" />
        </v-stepper-content>
        <v-stepper-content step="4">
          <PaymentConfirmation v-if="step == 4" :order="order" elevation="0" class="mb-12" />
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
  </div>
</template>
<style lang="scss" scoped>
.v-stepper__step {
  min-width: 20%;
}
</style>
